var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.95431 0 0 8.9543 0 20V40C0 51.0457 8.9543 60 20 60H40C51.0457 60 60 51.0457 60 40V20C60 8.95431 51.0457 0 40 0H20ZM35.1128 15C40.5313 15 44.9239 19.3926 44.9239 24.8111V35.1889C44.9239 40.6074 40.5313 45 35.1128 45H24.8111C19.3926 45 15 40.6074 15 35.1889V24.8111C15 19.3926 19.3926 15 24.8111 15H35.1128ZM39.1446 21.016C38.4457 20.3043 37.3158 20.3043 36.6169 21.016C35.9162 21.7296 35.9162 22.8897 36.6169 23.6033C37.3158 24.315 38.4457 24.315 39.1446 23.6033C39.8452 22.8897 39.8452 21.7296 39.1446 21.016ZM27.658 27.6511C26.3686 28.9437 26.3686 31.0564 27.658 32.349C28.9351 33.6291 30.9888 33.6291 32.2658 32.3489C33.5553 31.0563 33.5553 28.9437 32.2658 27.6511C30.9888 26.3709 28.9351 26.3709 27.658 27.6511ZM24.8797 24.8794C27.6901 22.0622 32.2338 22.0622 35.0442 24.8794C37.8618 27.7039 37.8618 32.2962 35.0442 35.1206C32.2338 37.9378 27.6901 37.9378 24.8797 35.1206C22.0621 32.2962 22.0621 27.7039 24.8797 24.8794Z",
    fill: "url(#paint0_linear_676_815)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_676_815",
    x1: 30,
    y1: 16.0386,
    x2: 47.1172,
    y2: 50.4452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00637B",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FDCE7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstB);
export default __webpack_public_path__ + "static/media/inst_b.c04c39a39001231522f194817b5a0452.svg";
export { ForwardRef as ReactComponent };